/*
 * File: LoginDialog.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Login with autologout alerts and jwt keep alives
 */

import React from "react";
import PropTypes from "prop-types";
import UIDialog from "components/ui/UIDialog";
import LoginPage from "../Login";
import LoginForm from "./LoginForm";

const LoginDialog = ({
  open,
  error,
  loggingIn,
  onSubmit,
  fullScreen = true,
  showLogout = true,
  wasAutoLoggedOut
}) => {
  if (fullScreen) {
    return (
      <UIDialog
        fullScreen={fullScreen}
        open={open}
        noPadding
        content={() => (
          <LoginPage
            wasAutoLoggedOut={wasAutoLoggedOut}
            showLogout={showLogout}
            error={error}
            loggingIn={loggingIn}
            onSubmit={onSubmit}
          />
        )}
      />
    );
  } else {
    return (
      <UIDialog
        fullScreen={fullScreen}
        open={open}
        title="Login"
        content={() => (
          <LoginForm
            showLogout={showLogout}
            error={error}
            loggingIn={loggingIn}
            onSubmit={onSubmit}
          />
        )}
      />
    );
  }
};

LoginDialog.propTypes = {
  wasAutoLoggedOut: PropTypes.bool,
  open: PropTypes.bool,
  error: PropTypes.node,
  loggingIn: PropTypes.bool,
  onSubmit: PropTypes.func,
  fullScreen: PropTypes.bool,
  showLogout: PropTypes.bool
};

export default LoginDialog;
